import styled from "styled-components";

export const RutaMaternaContainer = styled.div`
  width: 100%;
  font-family: var(--font-body);
  font-size: 13px;
  line-height: 1.4;
  color: #1f2328;
`;

export const TarjetaPaciente = styled.section`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 14px 18px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
`;

export const IdentidadPacienteBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 240px;
  flex: 1;
`;

export const NombrePaciente = styled.div`
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 16px;
  color: #0f172a;
  letter-spacing: -0.01em;
`;

export const DocumentoPaciente = styled.div`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  background: #f1f5f9;
  color: #475569;
  font-weight: 600;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
  font-variant-numeric: tabular-nums;
`;

export const MetricasGestacionGrid = styled.div`
  display: flex;
  align-items: stretch;
  gap: 12px;
  flex-wrap: wrap;
`;

export const MetricaCard = styled.div`
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 8px 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  min-width: 210px;
`;

export const EtiquetaDato = styled.span`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #64748b;
`;

export const DatoPaciente = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
  color: #0f172a;
  font-size: 13.5px;
  font-weight: 600;
`;

export const ValorNumerico = styled.span`
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  font-weight: 700;
  color: #1e293b;
`;

export const BadgeSemanas = styled.span`
  display: inline-flex;
  align-items: center;
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
  font-size: 11.5px;
  font-weight: 600;
  padding: 1px 7px;
  border-radius: 999px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

export const NotaSinActividades = styled.p`
  color: #5a6066;
  margin: 0;
  font-size: 13px;
`;

export const LeyendaContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin: 0 0 10px 2px;
  font-size: 12px;
`;

export const LeyendaItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
`;

export const PuntoColor = styled.span`
  width: 9px;
  height: 9px;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  display: inline-block;
  background: ${({ $bg }) => $bg || "#808080"};
`;

export const TextoEstadoLeyenda = styled.span`
  font-weight: 500;
  &.e-cumplida {
    color: #808080;
  }
  &.e-no-cumplida {
    color: #e97132;
  }
  &.e-en-curso {
    color: #f7c7ac;
  }
  &.e-pendiente {
    color: #d9d9d9;
  }
`;

export const TablaWrapper = styled.div`
  background: #ffffff;
  border: 1px solid #e3e5e8;
  border-radius: 7px;
  max-height: 520px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`;

export const TablaRuta = styled.table`
  border-collapse: collapse;
  width: 100%;
`;

export const ThRuta = styled.th`
  position: sticky;
  top: 0;
  z-index: 2;
  background: #ffffff;
  text-align: left;
  text-transform: uppercase;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.04em;
  color: #1f2328;
  padding: 9px 10px;
  border-bottom: 1px solid #c9ccd1;
  white-space: nowrap;

  &.col-trim {
    width: 80px;
  }
  &.col-sem {
    width: 70px;
  }
  &.col-fecha {
    width: 108px;
  }
  &.col-res {
    width: 120px;
  }
`;

export const TrRuta = styled.tr`
  background: #ffffff;

  &:nth-child(even) {
    background: #f7f7f7;
  }

  &.e-cumplida {
    color: #808080;
  }
  &.e-no-cumplida {
    color: #e97132;
  }
  &.e-en-curso {
    color: #f7c7ac;
  }
  &.e-pendiente {
    color: #d9d9d9;
  }

  &:last-child td {
    border-bottom: none;
  }
`;

export const TdRuta = styled.td`
  padding: 6px 10px;
  height: 30px;
  vertical-align: middle;
  border-bottom: 1px solid #edeef0;
  font-family: var(--font-body);

  &.num {
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  }
  &.actividad {
    white-space: normal;
    overflow-wrap: break-word;
  }
  &.col-trim {
    width: 80px;
  }
  &.col-sem {
    width: 70px;
  }
  &.col-fecha {
    width: 108px;
  }
  &.col-res {
    width: 120px;
  }
`;

export const LoadingBox = styled.div`
  padding: 36px 20px;
  text-align: center;
  color: #5a6066;
  font-family: var(--font-body);
  font-size: 13px;
`;

